import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import * as cookie from 'cookie';

import {ProgressBar} from './ProgressBar';

import {CustomComponent} from '../components';
import dialog from '../dialog';
import {setupMultivariateTest} from '../multivariatetesting';
import {document, window} from '../util';

export class BaseApp extends CustomComponent {
    allowBanners: boolean;

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.allowBanners = true;

        const appGlobals = this.getAppGlobalsFromProps(props);
        // The router is added to the context by the inferno-router
        // Route/Switch component. This is the first place we have access to it
        // in our own code.
        appGlobals.router = context.router;
        // This is used for testing dialogs in dev and for flagging.
        const query = new URLSearchParams(
            appGlobals.router.history.location.search);
        if (query.has('open-dialog') && process.env.BROWSER) {
            appGlobals.request.console.log(
                'open-dialog', query.get('open-dialog'));
            const [dialogName, dialogDataStr] =
                query.get('open-dialog').split(':');
            const dialogData: Record<string, boolean|string> = {viaQuery: true};
            if (dialogDataStr) {
                for (const [k, v] of new URLSearchParams(
                    dialogDataStr).entries()) {
                    dialogData[k] = v;
                }
            }
            appGlobals.request.console.log(
                'opening', dialogName, 'with data', dialogData);
            window.setTimeout(() => {
                dialog.open(dialogName, dialogData);
            }, 800);
        }
    }
    getAppGlobalsFromProps(props: jsx.Props) {
        return props.staticContext || props.appGlobals;
    }
    fixContext() {
        return;
    }
    beforeChildren() {
        return;
    }
    afterChildren() {
        return;
    }
    render() {
        const appGlobals = this.getAppGlobalsFromProps(this.props);

        this.context.CONSTANTS = appGlobals.CONSTANTS;
        this.context.PRIVATE_CONSTANTS = appGlobals.PRIVATE_CONSTANTS;
        this.context.request = appGlobals.request;
        this.context.storageService = appGlobals.storageService;

        setupMultivariateTest(this.context, process.env.BROWSER, window.ga);

        this.context.featureFlags = {
            enableInternalLocales: false,
        };

        // Override feature flags using url query param.
        const query = new URLSearchParams(
            this.context.router.history.location.search);
        const enableFeatureFlags = (
            query.get('enableFeatureFlags') || '').split(',');
        for (const flag of enableFeatureFlags) {
            this.context.featureFlags[flag] = true;
        }

        this.context.countryCode = process.env.BROWSER &&
            cookie.parse((document?.cookie) || '').countryCode;

        this.context.response = appGlobals.response;

        this.context.cacheService = appGlobals.cacheService;
        this.context.uploadService = appGlobals.uploadService;
        this.context.httpService = appGlobals.httpService;
        this.context.apiService = appGlobals.apiService;
        this.context.loggedTimer = appGlobals.loggedTimer;
        this.context.authService = appGlobals.authService;
        this.context.googleAuthService = appGlobals.googleAuthService;
        this.context.gtService = appGlobals.gtService;
        this.context.languages = appGlobals.languages;

        this.context.store = appGlobals.store;

        const gtService = this.context.gtService;
        this.context.GOOGLE_TOS_URL = `https://policies.google.com/terms?hl=${gtService.gt.locale}`;
        this.context.GOOGLE_PP_URL = `https://policies.google.com/privacy?hl=${gtService.gt.locale}`;
        this.context.GOOGLE_CONTACT_URL = `https://support.google.com/tenor/gethelp?hl=${gtService.gt.locale}`;

        this.fixContext();

        const children = this.props.children;
        return (<div className="BaseApp">
            { this.beforeChildren() }
            { children }
            <ProgressBar />
            { this.afterChildren() }
        </div>);
    }
}
